import firedux from '../firedux'
import {getState, dispatch} from '../store'

import {
  EXPERT_SESSION_COUNTS_ENDPOINT
} from '../../config/constants'

import setUserSessionsCount from '../actions/set_user_sessions_count'

const onUserSessionsCount = (uid, snapshot) => {
  const count = snapshot.val() || 0

  dispatch(setUserSessionsCount(count, uid))

  return snapshot
}

export default (uid) => {
  if (!uid) return

  const sessionsCount = getState().getIn(['sessions', '_counts', uid])

  if (sessionsCount) return

  const ENDPOINT = `${EXPERT_SESSION_COUNTS_ENDPOINT}/${uid}`

  return firedux.ref.child(ENDPOINT).once('value')
    .then(onUserSessionsCount.bind(null, uid))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/user_sessions_count.js
 **/